import { Form, FormField, FormSection, FormType } from '../../../../../common/components/reactive-form-builder/interfaces/form.interface';
import { FincasEnvironmentDefinition } from '../environment-variables';
import { FincasListsDefinition } from './list-variables';
import { StorageManager } from '../../../../../common/storage-manager.class';
import { FormRequestTypes } from '../../../../../common/components/reactive-form-builder/form-request';
import { InputType } from '../../../../../common/components/reactive-form-builder/interfaces/input.interface';
import { FincasModel } from '../../../../../models/form-common/fincas.module';
import { environment } from 'src/environments/environment';

export class FincasFormDefinition {    
  public formType!: FormType;

  public env: FincasEnvironmentDefinition = new FincasEnvironmentDefinition();

  public lists: FincasListsDefinition = new FincasListsDefinition();

  public usuario = StorageManager.getUser();

  public model: FincasModel = {} as FincasModel;
    
  public formFieldsSection!: FormSection<object>;

  public formFieldsTitular!: FormSection<object>;

  public formFieldsResponsable!: FormSection<object>;
    
  public formFields!: Form<FincasModel>;

  public fieldNames: FormField<any>[] = [];

  public fieldLabels: string[] = [];

  public showDialogExportREA = false;

  constructor(
    type: FormRequestTypes, 
    _model: Record<string,string>,
    table: (string[] | string[][])[] | null
  ) {
    this.formType = +type;
        
    this.formFields = {
      name: 'fincas',
      type: this.formType,
      sections: this.getFormSections(),
      table: { title: '', showIndex: false, data: table?.[0], style: table?.[1]},
      uploadButton: false,
      signed: false
    };
  }



  public getFormFields(): FormField<any>[] {
    const formFields: FormField<any>[] = [
      {
        name: 'id_cliente',
        vinculatedFields: undefined,
        label: this.env.activateREA
          ? 'Titular'
          : 'Cliente',
        input: { 
          type: InputType.DROPDOWN_SEARCH, 
          isEditable: true,
          data: this.lists.clientes,
          defaultValue: StorageManager.getClient()?.id !== undefined ? StorageManager.getClient() : null,
          dropdownConfiguration: {
            valuePrimaryKey: 'id'
          }
        },
        width: 3,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: true,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: this.env.hasClients
        },
        order: 1
      },
      {
        name: 'razon_social',
        vinculatedFields: undefined,
        label: 'Razón social',
        input: { type: InputType.TEXT, isEditable: true },
        width: 3,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: this.env.showFincasRazonSocial
        },
        order: 2
      },
      {
        name: 'nombre',
        vinculatedFields: undefined,
        label: 'Nombre de ' + this.env.fincaName,
        input: { type: InputType.TEXT, isEditable: true },
        width: 3,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: true,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: true
        },
        order: 3
      },
      {
        name: 'nif',
        vinculatedFields: this.env.hasClients ? ['id_cliente'] : undefined,
        label: 'NIF',
        input: {
          type: this.env.activateREA ? InputType.ONLY_TEXT : InputType.TEXT,
          defaultValue: !this.env.hasClients ? this.env.user.nif : '-',
          isEditable: true,
        },
        updateValue: () => this.lists.clientes.selected?.nif,
        width: 3,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: this.env.fincasNifRequired || this.env.activateREA,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: true
        },
        order: environment.features.hasClients ? 1 : 4,
      },
      {
        name: 'codigo',
        vinculatedFields: undefined,
        label: 'Código',
        input: { type: InputType.TEXT, isEditable: true },
        width: 3,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: this.env.showFincasCodigo
        },
        order: 5
      },
      {
        name: 'registro_nacional',
        vinculatedFields: undefined,
        label: 'Registro Nacional',
        input: { type: InputType.TEXT, isEditable: true },
        width: 3,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: this.env.appName !== 'gardengest' && !this.env.activateREA
        },
        order: 6
      },
      {
        name: 'registro_autonomico',
        vinculatedFields: undefined,
        label: 'Registro Autonómico',
        input: { type: InputType.TEXT, isEditable: true },
        width: 3,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: this.env.appName !== 'gardengest' && !this.env.activateREA
        },
        order: 7
      },
      {
        name: 'codigo_REA',
        vinculatedFields: undefined,
        label: 'REA',
        input: { type: InputType.TEXT, isEditable: true },
        width: 3,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: true,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: this.env.activateREA
        },
        order: 8
      },
      {
        name: 'direccion',
        vinculatedFields: this.env.hasClients ? ['id_cliente'] : undefined,
        label: 'Dirección',
        input: { type: this.env.activateREA ? InputType.ONLY_TEXT : InputType.TEXT, isEditable: true },
        updateValue: () => this.lists.clientes.selected?.direccion,
        width: 3,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: true
        },
        order: 9
      },
      {
        name: 'localidad',
        vinculatedFields: this.env.hasClients ? ['id_cliente'] : undefined,
        label: 'Localidad',
        input: { type: this.env.activateREA ? InputType.ONLY_TEXT : InputType.TEXT, isEditable: true },
        updateValue: () => this.lists.clientes.selected?.localidad,
        width: 3,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: true
        },
        order: 10
      },
      {
        name: 'codigo_postal',
        vinculatedFields: this.env.hasClients ? ['id_cliente'] : undefined,
        label: 'Código Postal',
        input: {
              type: this.env.activateREA ? InputType.ONLY_TEXT : InputType.TEXT,
              isEditable: true
        },
        updateValue: () => this.lists.clientes.selected?.codigo_postal,
        width: 3,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: true
        },
        order: 11,
      },
      {
        name: 'provincia',
        vinculatedFields: this.env.hasClients ? ['id_cliente'] : undefined,
        label: 'Provincia',
        input: { type: this.env.activateREA ? InputType.ONLY_TEXT : InputType.TEXT, isEditable: true },
        updateValue: () => this.lists.clientes.selected?.provincia,
        width: 3,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: true
        },
        order: 12
      },
      {
        name: 'telefono',
        vinculatedFields: this.env.hasClients ? ['id_cliente'] : undefined,
        label: 'Teléfono',
        input: { 
          type: environment.features.activateREA ? InputType.ONLY_TEXT : InputType.NUMERIC, 
          defaultValue: !this.env.hasClients ? this.env.user.telefono : '-',
          isEditable: true},
        updateValue: () => this.lists.clientes.selected?.telefono,
        width: 3,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: true
        },
        order: 13        
      },
      {
        name: 'movil',
        vinculatedFields: this.env.hasClients ? ['id_cliente'] : undefined,
        label: 'Móvil',
        input: { type: this.env.activateREA ? InputType.ONLY_TEXT : InputType.NUMERIC, isEditable: true },
        updateValue: () => this.lists.clientes.selected?.telefono,
        width: 3,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: !environment.features.activateREA
        },
        order: 14  
      },
      {
        name: 'email',
        vinculatedFields: this.env.hasClients ? ['id_cliente'] : undefined,
        label: 'Email',
        input: { type: this.env.activateREA ? InputType.ONLY_TEXT : InputType.TEXT, isEditable: true },
        updateValue: () => this.lists.clientes.selected?.email,
        width: 3,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: true
        },
        order: 15
      },
      {
        name: 'superficie',
        vinculatedFields: undefined,
        label: 'Superficie',
        input: { type: InputType.TEXT, isEditable: true },
        width: 3,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: this.env.appName !== 'avafitogest'
        },
        order: 16
      },
      {
        name: 'tipo_explotacion',
        vinculatedFields: undefined,
        label: 'Tipo de explotación',
        input: { 
          type: InputType.DROPDOWN, 
          isEditable: true,
          data: this.lists.tipos
        },
        width: 3,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: this.env.showTipoExplotacion
        },
        order: 17
      },
      {
        name: 'alquilado',
        vinculatedFields: undefined,
        label: 'Alquilado',
        input: { type: InputType.SWITCH, isEditable: true },
        width: 3,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: this.env.appName === 'covidai'
        },
        order: 18
      },
      {
        name: 'ids_productos',
        vinculatedFields: undefined,
        label: 'Productos (Fertirrigación)',
        input: { 
          type: InputType.MULTISELECT, 
          isEditable: true,
          data: this.lists.productos
        },
        width: 3,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: this.env.showFincasProductos
        },
        order: 19    
      },
      {
        name: 'observaciones',
        vinculatedFields: undefined,
        label: 'Observaciones Cliente',
        input: { type: InputType.TEXTAREA, isEditable: true },
        width: 3,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: this.env.appName === 'gardengest'
        },
        order: 20
      },
      {
        name: 'propiedad',
        vinculatedFields: undefined,
        label: 'Propiedad',
        input: { 
          type: InputType.DROPDOWN, 
          isEditable: true,
          data: this.lists.propiedad
         },
        width: 3,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: this.env.appName === 'agropecuariaramirogruas'
        },
        order: 21
      },
      {
        name: 'ccc',
        vinculatedFields: undefined,
        label: 'CCC',
        input: { type: InputType.TEXT, isEditable: true },
        width: 3,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: this.env.appName === 'campanaragricola'
        },
        order: 22
      },
    ];

    this.fieldNames = this.fieldNames.concat(formFields.filter((it) => it.conditions.isVisible));
    this.fieldLabels = this.fieldLabels.concat(formFields.filter((it) => it.conditions.isVisible).map(it => it.label));
    return formFields.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
  }

  public getTitularFields(isSectionVisible: boolean): FormField<any>[] {
    const titularFields: FormField<any>[] = [
      {
            name: 'titular_nombre',
            vinculatedFields: undefined,
            label: 'Titular Nombre',
            input: { type: InputType.TEXT, isEditable: true },
            width: 3,
            conditions: {
              isRememberedOnDuplicate: true,
              isRequired: false,
              isRetained: false,
              hasUndoEnabled: false,
              isVisible: isSectionVisible,
            },
            order: 1
          },
          {
            name: 'titular_nif',
            vinculatedFields: undefined,
            label: 'Titular NIF',
            input: { type: InputType.TEXT, isEditable: true },
            width: 3,
            conditions: {
              isRememberedOnDuplicate: true,
              isRequired: false,
              isRetained: false,
              hasUndoEnabled: false,
              isVisible: isSectionVisible,
            },
            order: 2
          },
          {
            name: 'titular_direccion',
            vinculatedFields: undefined,
            label: 'Titular Dirección',
            input: { type: InputType.TEXT, isEditable: true },
            width: 3,
            conditions: {
              isRememberedOnDuplicate: true,
              isRequired: false,
              isRetained: false,
              hasUndoEnabled: false,
              isVisible: isSectionVisible,
            },
            order: this.env.appName === 'agrogestSEIX' ? 2 : 3
          },
          {
            name: 'titular_localidad',
            vinculatedFields: undefined,
            label: 'Titular Localidad',
            input: { type: InputType.TEXT, isEditable: true },
            width: 3,
            conditions: {
              isRememberedOnDuplicate: true,
              isRequired: false,
              isRetained: false,
              hasUndoEnabled: false,
              isVisible: isSectionVisible,
            },
            order: 3
          },
          {
            name: 'titular_codigo_postal',
            vinculatedFields: undefined,
            label: 'Titular Código Postal',
            input: { type: InputType.TEXT, isEditable: true },
            width: 3,
            conditions: {
              isRememberedOnDuplicate: true,
              isRequired: false,
              isRetained: false,
              hasUndoEnabled: false,
              isVisible: isSectionVisible,
            },
            order: 4
          },
          {
            name: 'titular_provincia',
            vinculatedFields: undefined,
            label: 'Titular Provincia',
            input: { type: InputType.TEXT, isEditable: true },
            width: 3,
            conditions: {
              isRememberedOnDuplicate: true,
              isRequired: false,
              isRetained: false,
              hasUndoEnabled: false,
              isVisible: isSectionVisible,
            },
            order: 5
          },
          {
            name: 'titular_telefono',
            vinculatedFields: undefined,
            label: 'Titular Teléfono',
            input: { type: InputType.TEXT, isEditable: environment.appName !== 'agrogestSIEX' },
            width: 3,
            conditions: {
              isRememberedOnDuplicate: true,
              isRequired: false,
              isRetained: false,
              hasUndoEnabled: false,
              isVisible: isSectionVisible,
            },
            order: 6
          },
          {
            name: 'titular_email',
            vinculatedFields: undefined,
            label: 'Titular Email',
            input: { type: InputType.TEXT , isEditable: true},
            width: 3,
            conditions: {
              isRememberedOnDuplicate: true,
              isRequired: false,
              isRetained: false,
              hasUndoEnabled: false,
              isVisible: isSectionVisible,
            },
            order: 7
          },
          {
            name: 'titular_tipo',
            vinculatedFields: undefined,
            label: 'Tipo Representación',
            input: { type: InputType.TEXT, isEditable: true },
            width: 3,
            conditions: {
              isRememberedOnDuplicate: true,
              isRequired: false,
              isRetained: false,
              hasUndoEnabled: false,
              isVisible: isSectionVisible,
            },
            order: 8
          },
    ];

    this.fieldNames = this.fieldNames.concat(titularFields.filter((it) => it.conditions.isVisible));
    this.fieldLabels = this.fieldLabels.concat(titularFields.filter((it) => it.conditions.isVisible).map(it => it.label));
    return titularFields.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
  }

  public getRepresentanteFields(isSectionVisible: boolean): FormField<any>[] {
    const representanteFields: FormField<any>[] = [
      {
            name: 'representante_nombre',
            vinculatedFields: undefined,
            label: 'Representante Nombre',
            input: { type: InputType.TEXT, isEditable: environment.appName !== 'agrogestSIEX' },
            width: 3,
            conditions: {
              isRememberedOnDuplicate: true,
              isRequired: false,
              isRetained: false,
              hasUndoEnabled: false,
              isVisible: isSectionVisible,
            },
            order: 1
          },
          {
            name: 'representante_nif',
            vinculatedFields: undefined,
            label: 'Representante NIF',
            input: { type: InputType.TEXT, isEditable: environment.appName !== 'agrogestSIEX' },
            width: 3,
            conditions: {
              isRememberedOnDuplicate: true,
              isRequired: false,
              isRetained: false,
              hasUndoEnabled: false,
              isVisible: isSectionVisible,
            },
            order: 2
          },
          {
            name: 'representante_email',
            vinculatedFields: undefined,
            label: 'Representante Email',
            input: { type: InputType.TEXT, isEditable: environment.appName !== 'agrogestSIEX' },
            width: 3,
            conditions: {
              isRememberedOnDuplicate: true,
              isRequired: false,
              isRetained: false,
              hasUndoEnabled: false,
              isVisible: isSectionVisible,
            },
            order: 3

          },
    ];

    this.fieldNames = this.fieldNames.concat(representanteFields.filter((it) => it.conditions.isVisible));
    this.fieldLabels = this.fieldLabels.concat(representanteFields.filter((it) => it.conditions.isVisible).map(it => it.label));
    return representanteFields.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
  }

  public getHiddenFields(): FormField<any>[] {
    const hiddenFields: FormField<any>[] = [
      {
        name: 'id',
        vinculatedFields: undefined,
        label: '',
        input: {
          type: InputType.HIDDEN,
          defaultValue: this.model.id,
          isEditable: false
        },
        width: 2,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: true,
        },
        order: 1
      },
      {
        name: 'id_usuario',
        vinculatedFields: undefined,
        label: '',
        input: {
          isEditable: false,
          defaultValue: this.env.applicationType === 'cropgest'
                    ? StorageManager.getClient()?.id_usuario ?? StorageManager.getUser().id
                    : StorageManager.getClient()?.id_usuario_asignado ??
                      this.model.id_usuario ?? StorageManager.getUser().id,
          type: InputType.HIDDEN,
        },
        updateValue: () =>  this.env.applicationType === 'cropgest'
                    ? StorageManager.getClient()?.id_usuario ?? StorageManager.getUser().id
                    : StorageManager.getClient()?.id_usuario_asignado ??
                      this.model.id_usuario ?? StorageManager.getUser().id,
        width: 3,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: true
        },
        order: 2
      },
    ];

    this.fieldNames = this.fieldNames.concat(hiddenFields.filter((it) => it.conditions.isVisible));
    this.fieldLabels = this.fieldLabels.concat(hiddenFields.filter((it) => it.conditions.isVisible).map(it => it.label));
    return hiddenFields.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
  }
    

  private getFormSections(): FormSection<any>[] {
    const sections: FormSection<any>[] = [
      {
        name: !this.env.activateREA ? 'Datos de ' + this.env.fincaName : '',
        width: 12,
        isVisible: true,
        fields: this.getFormFields(),
        order: 1
      },
      {
        name: 'Datos del Titular',
        width: 12,
        isVisible: !this.env.activateREA,
        fields: this.getTitularFields(!this.env.activateREA),
        order: 2
      }, 
      {
        name: 'Datos del Representante',
        width: 12,
        isVisible: this.env.activateREA,
        fields: this.getRepresentanteFields(this.env.activateREA),
        order: 3
      },
      {
        name: '',
        width: 12,
        isVisible: true,
        fields: this.getHiddenFields(),
        order: 4
      },
    ];

    return sections.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
  }
}